import abstractModel from '../../core/MercatelyModel';

const csrfToken = document.querySelector('[name=csrf-token]')?.content;
const resource = '/api/mia/chatbot/media';

const model = abstractModel(resource);

model.upload = (file, name = null) => {
  const formData = new FormData();
  formData.append('file', file);
  if (name) formData.append('name', name);
  return model.post(formData, { csrfToken });
};

model.update = (id, { name = null, file = null } = {}) => {
  if (!id) return Promise.reject(new Error('id is required'));
  const hasFile = !!file;
  if (hasFile) {
    const formData = new FormData();
    formData.append('id', id);
    formData.append('file', file);
    if (name) formData.append('name', name);
    return model.put(formData, { csrfToken });
  }
  return model.put({ id, ...(name ? { name } : {}) }, { csrfToken });
};

model.delete = (id) => model.remove({ id }, { csrfToken });

export default model;

